import { Box, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FullAnswer } from '../../../../../../service/actionPlans/actionPlanById'
import { useStyles } from './styles'

const MAX_VISIBLE_NODES = 4

export type CatalogAnswerDetailProps = {
  fullAnswer?: FullAnswer[]
  showPathLabel?: boolean
}

function CatalogAnswerDetail({ fullAnswer, showPathLabel = true }: CatalogAnswerDetailProps) {
  const { t } = useTranslation()
  const styles = useStyles()
  const [expanded, setExpanded] = useState<Record<number, boolean>>({})

  if (!fullAnswer?.length) return null

  const toggleExpanded = (index: number) => {
    setExpanded(prev => ({ ...prev, [index]: !prev[index] }))
  }

  return (
    <Box sx={styles.container}>
      {showPathLabel && (
        <Box sx={styles.header}>
          <Box sx={styles.badge}>
          <Typography sx={styles.badgeText}>
            {t('actionPlan.paths', { count: fullAnswer.length })}
          </Typography>
        </Box>
      </Box>
      )}

      <Box component="ul" sx={styles.list}>
        {fullAnswer.map((path, pathIndex) => {
          const isExpanded = !!expanded[pathIndex]
          const visibleItems = isExpanded
            ? path.configAnswer
            : path.configAnswer.slice(0, MAX_VISIBLE_NODES)
          const hiddenCount = path.configAnswer.length - MAX_VISIBLE_NODES

          return (
            <Box component="li" key={pathIndex} sx={styles.item}>
              <Box sx={styles.path}>
                <Box sx={styles.bullet} />
                {visibleItems.map((item, itemIndex) => (
                  <Box key={item.id ?? itemIndex} sx={styles.nodeWrapper}>
                    {itemIndex > 0 && <Typography sx={styles.separator}>›</Typography>}
                    <Typography sx={itemIndex === 0 ? styles.firstNode : styles.node}>
                      {item.name}
                    </Typography>
                  </Box>
                ))}
                {hiddenCount > 0 && (
                  <Box component="button" sx={styles.showMoreButton} onClick={(e) => { e.stopPropagation(); toggleExpanded(pathIndex) }}>
                    {isExpanded
                      ? t('actionPlan.showLessNodes')
                      : t('actionPlan.showMoreNodes')}
                  </Box>
                )}
              </Box>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

function CatalogAnswerBadge({ count }: { count: number }) {
  const { t } = useTranslation()
  const styles = useStyles()
  return (
    <Box sx={styles.badge}>
      <Typography sx={styles.badgeText}>
        {t('actionPlan.paths', { count })}
      </Typography>
    </Box>
  )
}

export { CatalogAnswerDetail, CatalogAnswerBadge }
